import * as React from 'react';
import { Grid, Header } from 'semantic-ui-react';
import { ErrorAlert } from '~/UI';
import { ErrorConsumer } from '~/ErrorHandler';
import { useSearchParams } from '~/Router';
import { LoginRoute } from '~/Application/routes';
import { Invitation } from '~/Password';
export var InvitationAccept = function () {
    var searchParams = useSearchParams();
    var token = searchParams.get('token');
    var userId = searchParams.get('user');
    if (token === null || userId === null) {
        return <LoginRoute.Redirect />;
    }
    return (<Grid style={{ height: '100vh' }} textAlign='center' verticalAlign='middle'>
			<Grid.Column style={{ maxWidth: 450 }} textAlign='left'>
				<Header>Dokončení registrace</Header>
				<ErrorConsumer>{function (error) { return <ErrorAlert>{error}</ErrorAlert>; }}</ErrorConsumer>
				<Invitation token={token} userId={userId}/>
			</Grid.Column>
		</Grid>);
};
